export class TicketStatus {
  id: number;
  object: string;
  userDescription: string;
  systemDescription: string;

  constructor() {}
}
